<template>
    <div class="session-info">
        <dl class="row">
            <dt class="col-sm-5">User:</dt>
            <dd class="col-sm-7">{{user}}</dd>

            <dt class="col-sm-5">Environment:</dt>
            <dd class="col-sm-7">{{environment}}</dd>

            <dt class="col-sm-5">Build Number:</dt>
            <dd class="col-sm-7">{{buildNumber}}</dd>

            <dt class="col-sm-5">Extension Build:</dt>
            <dd class="col-sm-7">{{extensionVersion}}</dd>

            <dt class="col-sm-5">Data Pump Build:</dt>
            <dd class="col-sm-7">{{dataPumpVersion}}</dd>

            <dt class="col-sm-5">Date:</dt>
            <dd class="col-sm-7">{{buildDate}}</dd>

        </dl>
        <textarea class="clip-copy-target" ref="sessionCopyTarget" v-model="sessionInfoCopyText" readonly></textarea>
        <div class="text-center">
            <a class="btn btn-link btn-theme" @click="copySessionInfo">Copy to clipboard</a>
        </div>
    </div>
</template>
<script>
    import { BuildInfo }  from "@/shared/models/configurationModels";

    export default {
        name: "SessionInfo",
        computed: {
            user() { return `${_.get(this.$store.getters, 'user.emailAddress')}`; },
            environment() { return _.get(this, 'buildInfo.buildEnv', ''); },
            buildImage() { return _.get(this, 'buildInfo.image', ''); },
            buildNumber() {
                return _.replace(_.split(this.buildImage, ":")[1], this.environment, '');
            },
            extensionVersion() { return _.get(this, 'buildInfo.extensionVersion', ''); },
            dataPumpVersion() { return _.get(this, 'buildInfo.dataPumpVersion', ''); },
            buildDate() { return _.get(this, 'buildInfo.buildDate', ''); },
            sessionInfoCopyText() { return `User:   \t${this.user}\nEnvironment:    \t${this.environment}\nBuild Number:  \t${this.buildNumber}\nExtension Build:   \t${this.extensionVersion}\nData Pump Build: \t${this.dataPumpVersion}\nDate:   \t${this.buildDate}`; },
        },
        methods: {
            copySessionInfo(){
                let sessionInfoTextArea = _.get(this, "$refs.sessionCopyTarget", null);
                if(!sessionInfoTextArea) return;

                sessionInfoTextArea.select();
                window.document.execCommand("copy");
                this.$toast.success("System info copied to clipboard.");
            }
        },
        data() {
            return {
                buildInfo: new BuildInfo()
            }
        },
        created () {
            const self = this;
            let apiPromise = self.$api.HealthApi.getApiBuildInfo();
            self.$rqBusy.wait(apiPromise)
                .then(result => {
                    self.buildInfo = new BuildInfo(result);
                })
                .catch(error => {
                    console.error(error);
                    self.$toast.error({ message: `Error loading System Information.` });
                });
        }
    }
</script>